export enum VendorAnniversaryAwardType {
    BUDIMEX = 1236,
    MURAPOL = 884,
    DOM_DEVELOPMENT = 955,
    ARCHE = 934,
    NICKEL_DEVELOPMENT = 1259,
    ANGEL_POLAND_GROUP = 7453,
    RED_REAL_ESTATE_DEVELOPMENT = 814,
    INVEST_KOMFORT = 887
}

export function getVendorAnniversaryAwardPrice(vendorId: VendorAnniversaryAwardType) {
    switch (vendorId) {
        case VendorAnniversaryAwardType.BUDIMEX:
            return "Najbardziej medialny deweloper";
        case VendorAnniversaryAwardType.MURAPOL:
            return "Najlepszy Marketing";
        case VendorAnniversaryAwardType.DOM_DEVELOPMENT:
            return "Deweloper Dekady, Inwestycja Dekady";
        case VendorAnniversaryAwardType.ARCHE:
            return "Inwestycja Dekady";
        case VendorAnniversaryAwardType.NICKEL_DEVELOPMENT:
            return "Inwestycja Dekady";
        case VendorAnniversaryAwardType.ANGEL_POLAND_GROUP:
            return "Inwestycja Dekady";
        case VendorAnniversaryAwardType.RED_REAL_ESTATE_DEVELOPMENT:
            return "Inwestycja Dekady";
        case VendorAnniversaryAwardType.INVEST_KOMFORT:
            return "Inwestycja Dekady";
        default:
            throw new Error("Unknown offer type");
    }
}
export enum VendorAnniversaryAwardType {
    BUDIMEX = 1236,
    MURAPOL = 884,
    DOM_DEVELOPMENT = 955,
    ARCHE = 934,
    NICKEL_DEVELOPMENT = 1259,
    ANGEL_POLAND_GROUP = 7453,
    RED_REAL_ESTATE_DEVELOPMENT = 814,
    INVEST_KOMFORT = 887
}

export function getVendorAnniversaryAwardPrice(vendorId: VendorAnniversaryAwardType) {
    switch (vendorId) {
        case VendorAnniversaryAwardType.BUDIMEX:
            return "Najbardziej medialny deweloper";
        case VendorAnniversaryAwardType.MURAPOL:
            return "Najlepszy Marketing";
        case VendorAnniversaryAwardType.DOM_DEVELOPMENT:
            return "Deweloper Dekady, Inwestycja Dekady";
        case VendorAnniversaryAwardType.ARCHE:
            return "Inwestycja Dekady";
        case VendorAnniversaryAwardType.NICKEL_DEVELOPMENT:
            return "Inwestycja Dekady";
        case VendorAnniversaryAwardType.ANGEL_POLAND_GROUP:
            return "Inwestycja Dekady";
        case VendorAnniversaryAwardType.RED_REAL_ESTATE_DEVELOPMENT:
            return "Inwestycja Dekady";
        case VendorAnniversaryAwardType.INVEST_KOMFORT:
            return "Inwestycja Dekady";
        default:
            throw new Error("Unknown offer type");
    }
}
